import script from "./esWeeklyCalendar.vue?vue&type=script&setup=true&lang=ts"
export * from "./esWeeklyCalendar.vue?vue&type=script&setup=true&lang=ts"

import "./esWeeklyCalendar.vue?vue&type=style&index=0&id=4cf413fc&scoped=true&lang=css"

import exportComponent from "/home/aschmuck/wk/eSklepios/medsw/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4cf413fc"]])

export default __exports__